import { Dataset } from '../../../../../../types/types';
import { formatStaticDateTime } from '../../../utils/formatStaticDateTime';
import { isDateTimeReferenceColumn } from './isDateTimeReferenceColumn';

// Returns a display formatter for the reference label field. Quicksearch only
// downloads id + label columns, so a label pointing at a dateTime element would
// otherwise render the raw server value. When the referenced element is dateTime
// we format it; every other type passes through unchanged.
export const getReferenceLabelFormatter = (
  dataset: Dataset | undefined,
  labelItem: string
): ((value: string) => string) => {
  if (!isDateTimeReferenceColumn(dataset, labelItem)) {
    return (value: string) => value;
  }

  return (value: string) => formatStaticDateTime(value) ?? value;
};
